import cepNo from './cepNo'
import dogumTarihi from './dogumTarihi'
import ePosta from './ePosta'
import kimlikNo from './kimlikNo'
import required from './required'
import smsDogrulamaKodu from './smsDogrulamaKodu'

export default {
    cepNo,
    dogumTarihi,
    ePosta,
    kimlikNo,
    required,
    smsDogrulamaKodu,
}